export default __webpack_public_path__ + "static/media/sticker-r.4d966152.png";